// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__wq8NP","group":"Page_group__2UwIm","bitdefenderLogo":"Page_bitdefenderLogo__35cm8"};